module.exports = __webpack_public_path__ + "static/media/piedra_clasica.11530ec1.jpg";